import { Dispatch, IAppState } from 'shared/common/state';
import {
  isListingForResidentialComplexSelector,
  residentialComplexLayoutsLastMetaCountSelector,
  residentialComplexLayoutsOnSelector,
} from 'shared/selectors/newbuildingLayouts';
import { fetchSearchMeta } from 'shared/services/fetchSearchMeta';
import { IApplicationContext } from 'shared/types/applicationContext';

import { newbuildingLayoutsOff } from '../newbuildingLayouts';
import { FILTERS_SEARCH_LAYOUT_SEARCH_REQUEST_START_REQUESTED } from './types';
import { TJsonQuery } from '../../../packages/JsonQuery';
import { makeSearch } from '../search/makeSearch';

export function makeSearchLayout(jsonQuery: TJsonQuery) {
  return async (dispatch: Dispatch, getState: () => IAppState, context: IApplicationContext) => {
    const state = getState();
    const layoutToggle = residentialComplexLayoutsOnSelector(state);
    const layoutCount = residentialComplexLayoutsLastMetaCountSelector(state);
    const isNewbuilding = isListingForResidentialComplexSelector(state);

    if ((layoutToggle && !layoutCount) || !isNewbuilding) {
      dispatch(newbuildingLayoutsOff());
    }

    if (layoutToggle && layoutCount && isNewbuilding) {
      dispatch({
        type: FILTERS_SEARCH_LAYOUT_SEARCH_REQUEST_START_REQUESTED,
        jsonQuery,
      });
    } else {
      const { currentLocation } = getState();

      dispatch(
        makeSearch({
          jsonQuery,
          location: currentLocation,
          searchMeta: await fetchSearchMeta(context, { jsonQuery }),
        }),
      );
    }
  };
}
